import { normalizeTimestamp } from './dateFormatters';

/**
 * Normaliza los nombres de los campos de un item (manejar mayúsculas/minúsculas)
 * @param {Object} item - Item a normalizar
 * @param {Function} t - Función de traducción
 * @returns {Object} Item normalizado
 */
export function normalizeItemFields(item, t) {
  return {
    id: item.JobName || item.jobName || Date.now().toString(),
    jobName: item.JobName || item.jobName || "",
    supervisor: item.Supervisor || item.supervisor || "",
    agent: item.Agent || item.agent || "",
    // Priorizar Summary, luego insightsPrompt
    insight: item.Summary || item.summary || item.insightsPrompt || item.InsightsPrompt || t("insights.noSummaryAvailable"),
    // Convertir timestamp de Unix a ISO si es necesario
    timestamp: normalizeTimestamp(item.Timestamp || item.timestamp)
  };
}

